import { LegendStates, MouseSelectionStates, SelectedParams } from "types";

import { mpcCompatibleHoverLegends, mpcCompatibleSelectionParams } from "./mpcHighlights";

export function rateCumHoverLegends(states: Partial<MouseSelectionStates>) {
  return mpcCompatibleHoverLegends(states);
}

export function rateCumSelectionParams(states: Partial<LegendStates>): SelectedParams {
  return mpcCompatibleSelectionParams(states);
}
